<template>
  <div>
    <!-- Incoming Shipments Status CHange -->
    <div v-if="shippingRequest.port_status === 'INCOMING'" class="modal-card" style="width: 600px">
      <header class="modal-card-head is-primary">
        <h4 class="modal-card-title">Update Status</h4>
      </header>
      <section class="modal-card-body">
        <h4 class="is-flex">
          Current Status:
          <span
            class="currentStatus has-text-brown"
          >{{ shippingRequest.port_status }}</span>
        </h4>
        <br>
        <br>
        <b-field label="New Status">
          <b-select placeholder="Select Status" required>
            <option value="INCOMING">BERTHED</option>
          </b-select>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <button type="button" class="button is-primary" @click="onChangePortStatusToDocked">Update</button>
      </footer>
    </div>

    <!-- DOCKED Shipments status change-->
    <div v-if="shippingRequest.port_status === 'DOCKED'" class="modal-card" style="width: 600px">
      <header class="modal-card-head is-primary">
        <h4 class="modal-card-title">Update Status</h4>
      </header>
      <section class="modal-card-body">
        <h4 class="is-flex">
          Current Status:
          <span class="currentStatus has-text-brown">BERTHED</span>
        </h4>
        <br>
        <br>
        <b-field label="New Status" class="is-flex flex-column">
          <b-select v-model="dispatchValue" placeholder="Select Status" required>
            <option disabled value="">Please select dispatch method</option>
            <option v-for="option in dispatch" :value="option.value" :key="option.type">{{option.display}}</option>
          </b-select>
          <b-input v-if="dispatchValue==='DISPATCH_METHOD_SHIP'" v-model="ship_info" placeholder="Please provide the shipping destination" class="has-margin-top-10">

          </b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <button type="button" class="button is-primary" @click="onChangePortStatusToDispatch">Update</button>
      </footer>
    </div>

    <!-- DEPARTURE Shipments status change-->
    <div v-if="shippingRequest.port_status === 'DEPARTURE'" class="modal-card" style="width: 600px">
      <header class="modal-card-head is-primary">
        <h4 class="modal-card-title">Update Status</h4>
      </header>
      <section class="modal-card-body">
        <h4 class="is-flex">
          Current Status:
          <span class="currentStatus has-text-brown">DEPARTURE</span>
        </h4>
        <br>
        <br>
        <b-field label="New Status" class="is-flex flex-column">
          <b-select v-model="dispatchValue" placeholder="Select Status" required>
            <option disabled value="">Please select dispatch method</option>
            <option value="DISPATCH_METHOD_SHIP">BY SHIP/BARGE</option>
          </b-select>
          <b-input v-if="dispatchValue==='DISPATCH_METHOD_SHIP'" v-model="ship_info" placeholder="Please provide the ship's destination" class="has-margin-top-10" required>

          </b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <button type="button" class="button is-primary" @click="onChangePortStatusToDispatch">Update</button>
      </footer>
    </div>
  </div>
</template>

<script>
import { isNull } from 'util';
export default {
  name: "UpdateModal",
  props: {
    shippingRequest: Object,
    changePortStatusToDocked: Function,
    changePortStatusToDispatch: Function
  },

  data() {
    return {
      dispatch: [
        { 
          type: "TRUCK",
          display: "DISPATCH BY TRUCK",
          value: "DISPATCH_METHOD_TRUCK"
        },
        {
          type: "SHIP",
          display: "DISPATCH BY SHIP",
          value: "DISPATCH_METHOD_SHIP"
        }
      ],
      dispatchValue: '', 
      ship_info: null
    };
  },

  methods: {
    onChangePortStatusToDocked() {
      this.changePortStatusToDocked(this.shippingRequest);
      this.$parent.close();
    },
    onChangePortStatusToDispatch() {
      this.changePortStatusToDispatch(this.shippingRequest, this.dispatchValue, this.ship_info);
    }
  }
};
</script>
<style scoped>
.currentStatus {
  text-transform: uppercase;
  font-weight: bolder;
  margin-left: 15px;
}
</style>
